import React, { useEffect, useState, useRef } from 'react';
import { EmailCaptureForm } from './ui/EmailCaptureForm';
interface CtaSectionProps {
  onGetStarted: (email: string) => void;
  isSubmitted: boolean;
  submittedEmail: string;
}
export const CtaSection = ({
  onGetStarted,
  isSubmitted,
  submittedEmail
}: CtaSectionProps) => {
  const [visible, setVisible] = useState(false);
  const heroRef = useRef<HTMLElement | null>(null);
  useEffect(() => {
    // Get reference to hero section
    heroRef.current = document.querySelector('section');
    const observer = new IntersectionObserver(([entry]) => {
      // When hero section is not intersecting (out of view), show the CTA
      setVisible(!entry.isIntersecting);
    }, {
      threshold: 0,
      rootMargin: '-40px 0px 0px 0px' // Slight offset to make transition smoother
    });
    if (heroRef.current) {
      observer.observe(heroRef.current);
    }
    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);
  return <section className="py-20 bg-white" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-22">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-23">
          Quantify Your Culture—Join the Waitlist
        </h2>
        <p className="text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-24">
          Turn everyday team conversations into actionable, real-time
          metrics—free during beta.
        </p>
        <div className={`fixed bottom-8 left-0 right-0 z-40 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'}`} data-id="element-25">
          <div className="max-w-lg mx-auto bg-white rounded-full shadow-lg border border-gray-100 py-4 px-6" data-id="element-26">
            <EmailCaptureForm onSubmit={onGetStarted} isSubmitted={isSubmitted} submittedEmail={submittedEmail} className="w-full" data-id="element-27" />
          </div>
        </div>
      </div>
    </section>;
};